class MadToggleButtons {
  constructor(container) {
    this.container = container;
    
    // Check if the container already has a group identifier.
    let group = this.container.data('toggle-group');
    if (!group) {
      group = this._generateRandomHash();
      this.container.attr('data-toggle-group', group);
    }
    this.group = group;
    
    // 1. Process the buttons first.
    this.buttons = this.container.find('.mad-toggle__button[data-button-toggle-id]');
    this.buttons.each((index, button) => {
      const $button = jQuery(button);
      // Add the group attribute to the button if it doesn't have one.
      if (!$button.attr('data-toggle-group')) {
        $button.attr('data-toggle-group', group);
      }
    });
    
    // 2. Now, for each button, find matching toggle content elements (by comparing toggle IDs)
    // and add the group attribute to them.
    this.buttons.each((index, button) => {
      const toggleId = jQuery(button).data('button-toggle-id');
      // Find all elements with a matching data-toggle-id.
      jQuery(`[data-toggle-id="${toggleId}"]`).each((i, el) => {
        const $el = jQuery(el);
        // Only add the group attribute if it's not already set.
        if (!$el.attr('data-toggle-group')) {
          $el.attr('data-toggle-group', group);
        }
      });
    });
    
    this.init();
  }

  // Helper method to generate a short random hash (e.g., 6 characters).
  _generateRandomHash() {
    return Math.random().toString(36).substring(2, 8);
  }
  
  init() {
    this.buttons.on('click', (event) => {
      const button = jQuery(event.currentTarget);
      const toggleId = button.data('button-toggle-id');
      this.setActiveToggle(toggleId, button);
    });
  }
  
  setActiveToggle(toggleId, clickedButton) {
    const group = this.group;
    
    // Select only the toggle items and buttons within this group.
    const allElements = jQuery(`[data-toggle-id][data-toggle-group="${group}"]`);
    const allButtons  = jQuery(`[data-button-toggle-id][data-toggle-group="${group}"]`);
    
    // Remove 'active' from all elements and buttons in the group.
    allElements.removeClass('active');
    allButtons.removeClass('active');
    
    // Find the target toggle element using both toggle id and group.
    const targetElement = jQuery(`[data-toggle-id="${toggleId}"][data-toggle-group="${group}"]`);
    if (targetElement.length > 0) {
      targetElement.addClass('active');
    }
    
    // Always activate the clicked button.
    clickedButton.addClass('active');
  }
}

class MadToggleNavigation {
  constructor(container) {
    this.container = container;

    // Vor-/Zurück-Buttons ermitteln
    this.prevButton = this.container.find('[data-button-toggle-navigation="prev"]');
    this.nextButton = this.container.find('[data-button-toggle-navigation="next"]');

    // IDs aus dem Attribut data-toggle-nav-ids auslesen
    const idsString = this.container.data('toggle-nav-ids') || '';
    this.ids = idsString
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    // Events initialisieren
    this.init();
  }

  init() {
    this.prevButton.on('click', () => {
      this.showPrevious();
    });
    this.nextButton.on('click', () => {
      this.showNext();
    });
  }

  showNext() {
    // Aktiven Index ermitteln
    let activeIndex = this.getActiveIndex();

    if (activeIndex === -1) {
      // Falls kein Element aktiv ist, das erste aktivieren
      this.activateByIndex(0);
    } else {
      // Nächstes Element aktivieren
      const nextIndex = (activeIndex + 1) % this.ids.length;
      this.activateByIndex(nextIndex);
    }
  }

  showPrevious() {
    let activeIndex = this.getActiveIndex();
    if (activeIndex === -1) {
      // Falls kein Element aktiv ist, das letzte aktivieren
      this.activateByIndex(this.ids.length - 1);
    } else {
      let prevIndex = activeIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.ids.length - 1;
      }
      this.activateByIndex(prevIndex);
    }
  }

  /**
   * Ermittelt den Index des aktuell aktiven Toggle-Elements.
   * Gibt -1 zurück, wenn kein Element aktiv ist.
   */
  getActiveIndex() {
    let foundIndex = -1;
    for (let i = 0; i < this.ids.length; i++) {
      const id = this.ids[i];
      const $el = jQuery(`[data-toggle-id="${id}"]`);
      if ($el.hasClass('active')) {
        foundIndex = i;
        break;
      }
    }
    return foundIndex;
  }

  /**
   * Deaktiviert alle Toggle-Elemente und aktiviert das Element,
   * dessen ID dem übergebenen Index in this.ids entspricht.
   */
  activateByIndex(index) {
    if (index < 0 || index >= this.ids.length) {
      return;
    }

    // Alle Toggle-Elemente anhand der IDs deaktivieren
    for (const id of this.ids) {
      jQuery(`[data-toggle-id="${id}"]`).removeClass('active');
    }

    // Das Element mit der ID an der angegebenen Position aktivieren
    const newId = this.ids[index];
    jQuery(`[data-toggle-id="${newId}"]`).addClass('active');

    // Optional: Falls Toggle-Buttons existieren, diese ebenfalls aktualisieren
    jQuery('.mad-toggle__button[data-button-toggle-id]').removeClass('active');
    jQuery(`.mad-toggle__button[data-button-toggle-id="${newId}"]`).addClass('active');
  }
}

class MadTestimonialsToggle {
  constructor(container) {
      this.container = container;
      // Finde alle Testimonial Buttons und Toggles die innerhalb des Containers sind
      if (window.matchMedia('(max-width: 767px)').matches) {
        this.buttons = container.find('.mobile-toggle .mad-toggle__button[data-button-toggle-id]');
      } else {
        this.buttons = container.find('.desktop-toggle .mad-toggle__button[data-button-toggle-id]');
      }

      this.contents = container.find('[data-toggle-id]');
      this.activeIndex = 0;
      this.slideIntervall = 12000;
      this.currentColorIndex = 0;
      this._autoSlideInterval = null;
      
      // Hintergrund Farben des Overlays (für die Mobile Ansicht)
      /*
      this.colors = [
        'rgba(0, 0, 0, 0.9)',       // Black
        'rgba(200, 50, 40, 0.9)',   // Darker Red
        'rgba(0, 90, 200, 0.9)',    // Darker Blue
        'rgba(30, 120, 50, 0.9)',   // Darker Green
        'rgba(180, 100, 20, 0.9)',  // Darker Orange
      ];*/
      
      this.currentColorIndex = 0;

      this.init();
      this.startAutoSlide();

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.initSwiper();
      }
  }

  destroy() {
    this.buttons.off('click');
    if (this._autoSlideInterval) {
      clearInterval(this._autoSlideInterval);
      this._autoSlideInterval = null;
    }

    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  init() {
    this._buttonHandler = (event) => {
      const button = jQuery(event.currentTarget);
      const toggleId = button.data('button-toggle-id');
      this.setActiveToggle(toggleId, button);
      this.activeIndex = this.buttons.index(button);
      if (this.swiper) {
        this.swiper.slideTo(this.activeIndex, 300, false);
      }
      
      // Entferne auto-slide timer wenn der User manuell navigiert
      this.resetAutoSlide();
    };
    this.buttons.on('click', this._buttonHandler);
  }

  setActiveToggle(toggleId, clickedButton) {
      // Alle Elemente innerhalb des Containers
      const allElements = this.container.find('[data-toggle-id]');
      const allButtons = this.buttons;

      allElements.removeClass('active').css('--overlay-color', '');
      allButtons.removeClass('active');

      const targetElement = this.container.find(`[data-toggle-id="${toggleId}"]`);
      if (targetElement.length > 0) {
      targetElement.addClass('active');
      clickedButton.addClass('active');
      
      // Overlay Farbe setzen
      //targetElement.css('--mad-toggle__overlay-color', this.colors[this.currentColorIndex]);
      
      // Farbe für das nächste Element vorbereiten
      //this.currentColorIndex = (this.currentColorIndex + 1) % this.colors.length;
      }
  }

  // Start the auto-slide functionality
  startAutoSlide() {
    this.resetAutoSlide();
  }

  // Reset the auto-slide timer
  resetAutoSlide() {
    if (this._autoSlideInterval) {
      clearInterval(this._autoSlideInterval);
    }
    
    this._autoSlideInterval = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.buttons.length;

      const nextButton = this.buttons.eq(this.activeIndex);
      const toggleId = nextButton.data('button-toggle-id');
      
      if (this.swiper) {
        this.swiper.slideTo(this.activeIndex, 300, false);
      }

      this.setActiveToggle(toggleId, nextButton);
    }, this.slideIntervall);
  }

  initSwiper() {
    $dependencyManager.addDependencyCallback('swiper', () => {
      this.swiper = new Swiper(this.container.find('.swiper-toggle-buttons-mobile')[0], {
        allowTouchMove: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        speed: 300,
        on: {
          slideChangeTransitionEnd: () => {
            const activeIndex = this.swiper.activeIndex;
            const $activeButton = this.container.find('.swiper-toggle-buttons-mobile .swiper-slide')
              .eq(activeIndex)
              .find('.mad-toggle__button');
            if ($activeButton.length) {
              $activeButton.trigger('click');
            }
          }
        }
      });
    });
  }
}

function initializeToggles() {
  // 1) Standard-Buttons
  jQuery('.mad-toggle__container:not(.mad-toggle__container--testimonials):has(.mad-toggle__button)').each(function () {
    new MadToggleButtons(jQuery(this));
  });

  // 2) Navigation
  jQuery('.mad-toggle__container.mad-toggle__container--navigation').each(function () {
    new MadToggleNavigation(jQuery(this));
  });

  // 3) Testimonial
  initializeTestimonialsToggles();
}

let madTestimonialsToggleInstances = [];
function initializeTestimonialsToggles() {
  destroyTestimonialsToggles();

  jQuery('.mad-toggle__container.mad-toggle__container--testimonials').each(function () {
      const instance = new MadTestimonialsToggle(jQuery(this));
      madTestimonialsToggleInstances.push(instance);
  });
}

function destroyTestimonialsToggles() {
  madTestimonialsToggleInstances.forEach(instance => {
      if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
      }
  });
  madTestimonialsToggleInstances = [];
}

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

jQuery(document).ready(function () {
  initializeToggles();
});

jQuery(window).resize(debounce(function () {
  initializeTestimonialsToggles();
}, 250));